function SvgComponent(props: any) {
    return (
      <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.75 8.084h-5.331l4.617-2.666-.916-1.586-4.617 2.665 2.665-4.617-1.586-.915L9.916 5.58V.25H8.084v5.331L5.418.965l-1.586.915 2.665 4.616L1.88 3.832.964 5.418l4.617 2.666H.25v1.832h5.33L.964 12.582l.916 1.587 4.617-2.666-2.665 4.617 1.586.916 2.666-4.617v5.331h1.832v-5.445l2.715 4.702 1.487-.859-2.715-4.703 4.716 2.723.916-1.586-4.616-2.666h5.33V8.084h.001zM9 11.491A2.488 2.488 0 016.51 9a2.492 2.492 0 014.25-1.762A2.492 2.492 0 019 11.49z"
          fill="#625DF5"
        />
      </svg>
    )
}
  
  export default SvgComponent